import React, { useState } from 'react';

import { PATHS } from 'AppConstants';
import { FaqTitle, FaqArrow, FaqItemWrap, FaqAns } from './faqStyles';

const FaqItem = ({ data = {}, isMobile }) => {
	const [active, setActive] = useState(false);

	const { title, desc, list = [] } = data;
	return (
		<FaqItemWrap itemScope itemProp='mainEntity' itemType={`${PATHS.SEO_SCHEMA_URL}/Question`}>
			<FaqTitle
				justify='space-between'
				active={active} onClick={()=>{
					setActive(!active);
				}}>
				<span itemProp='name'>{title}</span>
				<FaqArrow active={active} />
			</FaqTitle>
			<FaqAns
				active={active}
				top_M='20'
				fsize={isMobile ? '12px' : '16px'}
				itemScope
				itemProp='acceptedAnswer'
				itemType={`${PATHS.SEO_SCHEMA_URL}/Answer`}>
				<p itemProp='text'>
					{desc}
					<ul>
						{list.map((step, i) => (
							<li key={i}>{step}</li>
						))}
					</ul>
				</p>
			</FaqAns>
		</FaqItemWrap>
	);
};

export default FaqItem;
